import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'
import {
  isEventKeyEnter,
  isEventKeySpaceBar,
  preventDefault,
} from '../../../../utils/events'
import { DashboardListRow } from '../../../DashboardBirdview'
import { getListingUnitLabel } from '../../../RentalPortalListing'
import { RentalPortalViewingDateTile } from '../../../RentalPortalViewing'
import { useRentalPortalOverviewLink } from '../RentalPortalOverview.hooks'

import { OverviewViewingText } from './OverviewViewingText'
import {
  QA_NAME_OVERVIEW_VIEWING_ROW,
  QA_NAME_OVERVIEW_VIEWING_ROW_APPLICANT,
  QA_NAME_OVERVIEW_VIEWING_ROW_UNIT,
} from './RentalPortalOverviewViewingRow.constants'
import {
  getOverviewViewingProfileLink,
  getOverviewViewingTimeLabel,
} from './RentalPortalOverviewViewingRow.utils'

import * as styles from './RentalPortalOverviewViewingRow.module.css'

function RentalPortalOverviewViewingRow({ row }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { handleClickLink, handleMouseDownLink } = useRentalPortalOverviewLink({
    link: getOverviewViewingProfileLink(row),
  })

  function handleKeyDown(event) {
    if (isEventKeyEnter(event) || isEventKeySpaceBar(event)) {
      preventDefault(event)

      handleClickLink(event)
    }
  }

  return (
    <div
      {...getQaSelector({ value: QA_NAME_OVERVIEW_VIEWING_ROW })}
      className={styles.RentalPortalOverviewViewingRow}
      role='button'
      tabIndex={0}
      onClick={handleClickLink}
      onKeyDown={handleKeyDown}
      onMouseDown={handleMouseDownLink}
    >
      <DashboardListRow
        Before={RentalPortalViewingDateTile}
        Meta={OverviewViewingText}
        Subtitle={OverviewViewingText}
        beforeProps={{ start: row.scheduled_at }}
        metaProps={{
          className: styles.applicant,
          qaName: QA_NAME_OVERVIEW_VIEWING_ROW_APPLICANT,
          text: row.applicant_display,
        }}
        subtitleProps={{
          qaName: QA_NAME_OVERVIEW_VIEWING_ROW_UNIT,
          text: getListingUnitLabel({ listing: row, t }),
        }}
        title={getOverviewViewingTimeLabel({
          locale,
          scheduledAt: row.scheduled_at,
          timezone,
        })}
      />
    </div>
  )
}

export default RentalPortalOverviewViewingRow
